export const errors = {
    VALIDATION_FAILED: "চিহ্নিত ঘরগুলো আবার দেখুন।",
    UNAUTHENTICATED: "অনুগ্রহ করে আবার সাইন ইন করুন।",
    FORBIDDEN: "এই কাজটি করার অনুমতি আপনার নেই।",
    NOT_FOUND: "এটি খুঁজে পাওয়া যায়নি। হয়তো মুছে ফেলা হয়েছে।",
    CONFLICT: "অন্য কেউ এটি পরিবর্তন করেছেন। রিলোড করে আবার চেষ্টা করুন।",
    BUSINESS_RULE_VIOLATION: "এই কাজটি করা যাবে না।",
    RATE_LIMITED: "অনেকবার চেষ্টা করা হয়েছে। একটু অপেক্ষা করে আবার চেষ্টা করুন।",
    INTERNAL: "আমাদের দিকে কোনো সমস্যা হয়েছে। আবার চেষ্টা করুন।",
    SERVICE_UNAVAILABLE: "সার্ভিসটি সাময়িকভাবে বন্ধ আছে। কিছুক্ষণ পর আবার চেষ্টা করুন।",
    INVALID_CREDENTIALS: "ইমেইল, ফোন নম্বর বা পাসওয়ার্ড সঠিক নয়।",
    INVALID_REFRESH_TOKEN: "আপনার সেশন শেষ হয়েছে। আবার সাইন ইন করুন।",
    ACCOUNT_LOCKED: "অনেকবার ভুল চেষ্টা হয়েছে। কিছুক্ষণের জন্য সাইন ইন বন্ধ থাকবে।",
    INVALID_OTP: "কোডটি ভুল অথবা মেয়াদ শেষ হয়ে গেছে।",
    LAST_OWNER: "একটি ব্যবসায় অন্তত একজন মালিক থাকতে হবে।",
    SYSTEM_ROLE_READ_ONLY: "নির্ধারিত রোলগুলো পরিবর্তন করা যায় না।",
    IDEMPOTENCY_KEY_REUSED: "এই অনুরোধটি আগেই ভিন্ন তথ্য দিয়ে পাঠানো হয়েছে। আবার শুরু করুন।",
    FILE_REJECTED: "ফাইলটি গ্রহণ করা হয়নি। ফাইলের ধরন ও আকার দেখুন।",
    PLAN_LIMIT_REACHED: "আপনার প্ল্যানের সীমা পূর্ণ হয়েছে। আরও যোগ করতে প্ল্যান আপগ্রেড করুন।",
    FEATURE_NOT_IN_PLAN: "আপনার প্ল্যানে এই ফিচারটি নেই। ব্যবহার করতে প্ল্যান আপগ্রেড করুন।",
    PHONE_REGISTERED: "এই মোবাইল নম্বরে আগেই অ্যাকাউন্ট আছে। সাইন ইন করুন।",
    EMAIL_REGISTERED: "এই ই-মেইলে আগেই অ্যাকাউন্ট আছে। সাইন ইন করুন।",
    LEGAL_OUTDATED: "শর্তাবলি এইমাত্র হালনাগাদ হয়েছে। পেজটি আবার লোড করে নতুন সংস্করণ মেনে নিন।",
    LEGAL_ACCEPTANCE_REQUIRED: "চালিয়ে যেতে হালনাগাদ শর্তাবলি মেনে নিন।",
    SIGNUP_DISABLED: "এখানে নতুন সাইন-আপ চালু নেই।",
    TOTP_ENROLMENT_REQUIRED: "চালিয়ে যেতে টু-স্টেপ সাইন-ইন চালু করুন।",
    TOTP_NOT_ENROLLED: "আগে নিজের টু-স্টেপ সাইন-ইন চালু করুন; সবার জন্য বাধ্যতামূলক থাকা অবস্থায় এটা বন্ধ করা যায় না।",
    DOWNGRADE_BLOCKED: "আপনার ব্যবসা ওই প্ল্যানের সীমার চেয়ে বেশি ব্যবহার করছে। আগে কিছু আর্কাইভ বা নিষ্ক্রিয় করুন।",
    COUPON_INVALID: "এই কুপনটি এখানে ব্যবহার করা যাবে না।",
    TRX_ID_USED: "এই বিকাশ ট্রানজেকশন আইডি আগেই ব্যবহার হয়েছে।",
    REQUEST_PENDING: "একটি পেমেন্ট আগেই অনুমোদনের অপেক্ষায় আছে।",
    ACCOUNT_RESTRICTED: "আপনার পেমেন্ট বকেয়া: আরও যোগ করতে প্ল্যানের পেমেন্ট করুন।",
    ACCOUNT_SUSPENDED: "আপনার অ্যাকাউন্ট স্থগিত। চালিয়ে যেতে প্ল্যানের পেমেন্ট করুন।",
    CLOSURE_CONFIRMATION_MISMATCH: "নিশ্চিত করতে ব্যবসার ওয়েব ঠিকানা হুবহু লিখুন।",
    DATA_EXPORT_RUNNING: "একটি ডেটা এক্সপোর্ট এখন তৈরি হচ্ছে। শেষ হওয়া পর্যন্ত অপেক্ষা করুন।",
    PASSWORD_CHANGE_REQUIRED: "চালিয়ে যেতে নিজের পাসওয়ার্ড দিন।",
    STAFF_HAS_ACCOUNT: "এই ব্যক্তির আগে থেকেই Sobthik অ্যাকাউন্ট আছে। তাকে একটি আমন্ত্রণ পাঠান: তিনি গ্রহণ করলে যোগ দেবেন।",
    STAFF_ACCOUNT_SHARED: "এই ব্যক্তির নিজের Sobthik অ্যাকাউন্ট আছে, তাই শুধু তিনিই পাসওয়ার্ড বদলাতে পারেন (Forgot password দিয়ে)।",
    CANNOT_DISABLE_SELF: "নিজের অ্যাক্সেস বন্ধ করা যায় না।",
    BARCODE_TAKEN: "এই বারকোডটি অন্য একটি পণ্যের।",
    NO_BARCODE: "কিছু পণ্যের এখনো বারকোড নেই। আগে সেগুলোর বারকোড তৈরি করুন।",
    SKU_TAKEN: "এই এসকেইউ অন্য একটি পণ্যে ব্যবহার হচ্ছে।",
    PRICE_ABOVE_MRP: "বিক্রয়মূল্য এমআরপির চেয়ে বেশি হতে পারে না।",
    CATEGORY_IN_USE: "এই ক্যাটাগরিতে এখনো পণ্য বা সাব-ক্যাটাগরি আছে। আগে সেগুলো সরান।",
    TOO_MANY_VARIANTS: "ভ্যারিয়েন্ট বেশি হয়ে গেছে: একটি পণ্যে সর্বোচ্চ ২৫০টি কম্বিনেশন থাকতে পারে।",
    SEARCH_UNAVAILABLE: "এই মুহূর্তে সার্চ কাজ করছে না। পণ্যের তালিকা ঠিকই দেখা যাবে।",
    IMPORT_NOT_VALIDATED: "এই ইমপোর্ট এখনো প্রয়োগ করার মতো অবস্থায় নেই (যাচাই চলছে, অথবা আগেই প্রয়োগ বা বাতিল হয়েছে)।",
    IMPORT_FILE_UNREADABLE: "ফাইলটি পড়া যায়নি। টেমপ্লেটটি .xlsx বা .csv ফাইল হিসেবে ব্যবহার করুন।",
    LOCATION_IN_USE: "এই লোকেশনে এখনো স্টক বা চলমান ট্রান্সফার আছে, তাই এখনই নিষ্ক্রিয় করা যাবে না।",
    INSUFFICIENT_STOCK: "এই লোকেশনে পণ্যটির যথেষ্ট স্টক নেই।",
    STOCK_NOT_TRACKED: "এই পণ্যের স্টক হিসাব রাখা হয় না।",
    LOCATION_INACTIVE: "এই লোকেশনটি নিষ্ক্রিয়। আগে এটি সক্রিয় করুন।",
    OPENING_STOCK_EXISTS: "এখানে পণ্যটির স্টক আগে থেকেই আছে। এর বদলে অ্যাডজাস্টমেন্ট করুন।",
    PRODUCT_HAS_STOCK: "পণ্যটির স্টক আছে, তাই এটি আর বদলানো যাবে না।",
    INVALID_TRANSITION: "বর্তমান অবস্থায় এই ধাপটি সম্ভব নয়। পেজটি আবার লোড করে চেষ্টা করুন।",
    COUNT_OVERLAP: "এর কিছু পণ্য এই লোকেশনে আগে থেকেই একটি চলমান স্টক গণনায় আছে।",
    COUNT_EMPTY: "স্টক রাখা হয় এমন কোনো পণ্য মেলেনি। লোকেশন বা ফিল্টার বদলান।",
    COUNT_TOO_LARGE: "একটি গণনার জন্য পণ্য অনেক বেশি। ক্যাটাগরি বা ব্র্যান্ড ধরে গুনুন।",
    SUPPLIER_ARCHIVED: "এই সরবরাহকারী আর্কাইভ করা আছে। আগে আর্কাইভ থেকে ফেরান।",
    OVER_RECEIPT: "পারচেজ অর্ডারে যা অর্ডার করা ও বাকি আছে তার চেয়ে বেশি।",
    OVER_RETURN: "এই রিসিটে যা এসেছিল (আগের ফেরতসহ বাদ দিয়ে) তার চেয়ে বেশি।",
    ALREADY_REVERSED: "এই পেমেন্ট আগেই বাতিল (রিভার্স) করা হয়েছে।",
    NOTHING_DUE: "এই কাস্টমারের কোনো বকেয়া নেই।",
    CREDIT_LIMIT_EXCEEDED: "এতে কাস্টমারের বাকির সীমা ছাড়িয়ে যাবে।",
    VARIANT_NOT_SELLABLE: "এই পণ্যটি আর্কাইভ করা, বিক্রি করা যাবে না।",
    INVALID_DISCOUNT: "ছাড়ের পরিমাণ মূল্যের চেয়ে বেশি।",
    NOT_A_DUPLICATE: "এই অর্ডারগুলো একটি আরেকটির ডুপ্লিকেট নয়।",
    NO_PHONE: "এই অর্ডারে এসএমএস পাঠানোর মতো ফোন নম্বর নেই।",
    AREA_IN_OTHER_ZONE: "এই এলাকা ইতিমধ্যে অন্য ডেলিভারি জোনে আছে।",
    REFUND_TOO_LARGE: "ফেরতের টাকা ফেরত আসা পণ্যের দামের চেয়ে বেশি।",
    ACCOUNT_ARCHIVED: "এই পেমেন্ট অ্যাকাউন্টটি আর্কাইভ করা।",
    COURIER_NOT_SUPPORTED: "এই কুরিয়ার এখনো সাপোর্ট করা হয় না।",
    COURIER_ACCOUNT_ARCHIVED: "এই কুরিয়ার অ্যাকাউন্টটি আর্কাইভ করা।",
    NO_COURIER_ACCOUNT: "আগে একটি কুরিয়ার অ্যাকাউন্ট যুক্ত করুন (বা বেছে নিন)।",
    ORDER_NOT_SHIPPABLE: "শুধু কনফার্ম বা প্যাক করা, ডেলিভারি ঠিকানাসহ অর্ডার বুক করা যায়।",
    SHIPMENT_EXISTS: "এই অর্ডারের কুরিয়ার বুকিং আগেই আছে।",
    COURIER_CANNOT_CANCEL: "এই কুরিয়ারে বুক করা পার্সেল এখান থেকে বাতিল করা যায় না; কুরিয়ার প্যানেল থেকে বাতিল করুন।",
    RTO_ALREADY_RECEIVED: "এই ফেরত পার্সেল আগেই গ্রহণ করা হয়েছে।",
    SHIPMENT_NOT_RETURNABLE: "কুরিয়ার এই পার্সেল ডেলিভারি করেছে; এর বদলে গ্রাহক ফেরত হিসেবে নিন।",
    PAYOUT_EXISTS: "এই কুরিয়ারের এই পেআউট আগেই ইমপোর্ট হয়েছে।",
    PHONE_BLOCKED: "এই নম্বরটি আগেই ব্লক করা আছে।",
    DEVICE_REVOKED: "একজন ম্যানেজার এই ডিভাইসটি সরিয়ে দিয়েছেন। চালিয়ে যেতে আবার পেয়ার করুন।",
    REGISTER_HAS_DEVICE: "এই ক্যাশ কাউন্টারে আগে থেকেই একটি ডিভাইস আছে। আগে সেটি বাতিল করুন।",
    RESYNC_REQUIRED: "এই ডিভাইসের ডেটা অনেক পুরোনো, আবার ডাউনলোড করতে হবে।",
    APP_UPGRADE_REQUIRED: "সিঙ্ক চালিয়ে যেতে POS অ্যাপ আপডেট করুন।",
    DOMAIN_TAKEN: "এই ডোমেইনটি ইতিমধ্যে একটি দোকানে যুক্ত আছে।",
    DOMAIN_LIMIT_REACHED: "একটি দোকানে সর্বোচ্চ ৫টি নিজস্ব ডোমেইন থাকতে পারে। আগে একটি সরিয়ে দিন।",
    SLUG_TAKEN: "অন্য একটি পণ্য এই ওয়েব ঠিকানা ব্যবহার করছে।",
    BOT_CHECK_FAILED: "আপনি রোবট নন তা যাচাই করা যায়নি। আবার চেষ্টা করুন।",
    SANDBOX_BUSY: "এই মুহূর্তে সব ডেমো দোকান ব্যবহার হচ্ছে। এক মিনিট পর আবার চেষ্টা করুন।",
    DEMO_SHOP: "এটি একটি ডেমো দোকান, তাই এখানে অর্ডার নেওয়া হয় না। ঘুরে দেখুন।",
    COUPON_NOT_APPLICABLE: "এই কুপন এই অর্ডারে প্রযোজ্য নয়।",
    COUPON_EXPIRED: "এই কুপনের মেয়াদ শেষ।",
    COUPON_MIN_ORDER: "অর্ডারটি কুপনের সর্বনিম্ন সীমার নিচে।",
    COUPON_LIMIT_REACHED: "এই কুপনের ব্যবহার শেষ। অর্ডার করতে এটি সরান।",
    CATEGORY_ARCHIVED: "এই খরচের খাতটি আর্কাইভ করা।",
    REPORT_RANGE_TOO_LONG: "আরও ছোট সময়কাল বেছে নিন।",
    ACCOUNT_EXISTS: "এই ইমেইল বা মোবাইল নম্বরে আগে থেকেই অ্যাকাউন্ট আছে। সাইন ইন করুন।",
    SIGN_UP_OFF: "এই দোকানে এভাবে নতুন অ্যাকাউন্ট খোলা যায় না।",
    CODE_REQUIRED: "আগে আমাদের পাঠানো কোডটি নিশ্চিত করুন।",
    CODE_SIGN_IN_OFF: "এই দোকানে কোড দিয়ে সাইন ইন চালু নেই। পাসওয়ার্ড ব্যবহার করুন।",
    PHONE_NOT_VERIFIED: "আগে আপনার মোবাইল নম্বর যাচাই করুন।",
    INVALID_GOOGLE_TOKEN: "Google দিয়ে সাইন ইন হয়নি। আবার চেষ্টা করুন।",
    GOOGLE_SIGN_IN_OFF: "এই দোকানে Google দিয়ে সাইন ইন চালু নেই।",
    PASSWORD_REQUIRED: "আগে একটি পাসওয়ার্ড দিন, যাতে Google ছাড়াও সাইন ইন করতে পারেন।",
    ALREADY_IN_LIBRARY: "এটি আপনার কাছে আগে থেকেই আছে। লাইব্রেরি থেকে খুলুন।",
    SIGN_IN_REQUIRED: "আগে সাইন ইন করুন: ডিজিটাল পণ্য আপনার অ্যাকাউন্টের লাইব্রেরিতে যায়।",
};
//# sourceMappingURL=errors.js.map